import "./App.scss";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/common/Navbar/Navbar";
import LandingPage from "./pages/landingPage/landingPage";
import ProjectFlow from "./pages/projectFlow/projectFlow";
import { WhatsappButton } from "./components/common/WhatsappButton/WhatsappButton";
// import EmailPreview from "./pages/emailPreview/emailPreview";

function App() {
    return (
        <BrowserRouter>
            <div className="App">
                <Routes>
                    <Route
                        path="/"
                        element={
                            <>
                                <Navbar />
                                <LandingPage />
                                <WhatsappButton
                                    phoneNumber="34000000000"
                                    message="Hola, me gustaría obtener más información sobre Atlyon."
                                />
                            </>
                        }
                    />
                    <Route path="/project-flow" element={<ProjectFlow />} />
                    {/* <Route path="/email-preview" element={<EmailPreview />} /> */}
                </Routes>
            </div>
        </BrowserRouter>
    );
}

export default App;
